module.exports = __webpack_public_path__ + "static/media/unavailable.71fdbda5.svg";